const oneyearoutColumns = [
  {
    zh: '整机编号',
    en: 'Device Code',
    dataIndex: 'deviceCode',
    key: 'deviceCode',
    width: 280
  },
  {
    zh: '公司名称',
    en: 'Company',
    dataIndex: 'company',
    key: 'company',
    width: 460
  },
  {
    zh: '机型',
    en: 'Model',
    dataIndex: 'model',
    key: 'model',
    width: 230
  },
  {
    zh: '保养设置时间(h)',
    en: 'Maintain Time Setting(h)',
    dataIndex: 'maintainTimeSetting',
    key: 'maintainTimeSetting'
  },
  {
    zh: '当前保养时间(h)',
    en: 'Maintain Time(h)',
    dataIndex: 'maintainTime',
    key: 'maintainTime'
  },
  {
    zh: '累积运行时间(h)',
    en: 'Running Time(h)',
    dataIndex: 'runTime',
    key: 'runTime'
  }
]

export {
  oneyearoutColumns
}
